module.exports = __webpack_public_path__ + "static/media/bitcoin.be35cc14.png";